<template>
  <div
    id="chartDietrySuggestions"
    class="dietry-suggestions-widget component container"
    :class="{
      rtl: readDirection === 'rtl'
    }"
  >
    <div
      class="row"
      style="padding: 1.25rem;"
    >
      <div
        v-if="secondarySample && secondarySample.identifier"
        class="col-12 mt-3"
      >
        <div class="p-4 rounded suggestions-label">
          {{ i18n.t('overview.foodIdeas.label.mainText') }}
          <span class="suggestions-label__sample">{{
            i18n.t('overview.foodIdeas.label.sampleA')
          }}</span>
        </div>
      </div>
      <div class="col-12 mt-1">
        <div class="row mt-3">
          <div class="col-md-12">
            <div class="shoppingTitle">
              <div class="row">
                <div class="col-md-8 col-sm-12">
                  <span class="title">{{
                    i18n.t('overview.foodIdeas.shoppingList.title')
                  }}</span>
                </div>
              </div>
            </div>
            <div class="shoppingSection">
              <p>{{ i18n.t('overview.foodIdeas.shoppingList.description') }}</p>
              <div
                class="mb-3"
              >
                {{ i18n.t('shoppingList.youExcluded') }}:
                {{ selectedExclusions.join(', ') }}
              </div>
              <template v-if="allFoods">
                <template v-for="food in allFoods">
                  <template v-if="filteredFoods(food.foodItems).length > 0">
                    <div
                      :key="`allFoodItems-${food.key}`"
                      class="header-img p-3"
                      :style="{
                        backgroundImage: `url('${imageUrl}dietrySuggestionHeaders-${food.key}.png')`
                      }"
                    >
                      <strong class="serif-font">{{ food.displayName }}</strong>
                    </div>
                    <div
                      id="shoppingItems"
                      :key="`shoppingItems-${food.key}`"
                      class="row pt-2 pb-4 no-gutters"
                    >
                      <div class="col-12 pr-1">
                        <ul class="list-group d-flex flex-wrap flex-row">
                          <template v-for="item in filteredFoods(food.foodItems)">
                            <li
                              :key="`foodInGroup-${item.key}`"
                              class="shopping-item col-md-6 col-sm-12"
                            >
                              <div class="shopping-item-content row">
                                <div class="col-lg-8 col-12">
                                  <div>
                                    <label
                                      class="small-label mb-0"
                                      :for="item.key"
                                    >{{ item.displayName }}</label>
                                  </div>
                                </div>
                              </div>
                            </li>
                          </template>
                        </ul>
                      </div>
                    </div>
                  </template>
                </template>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import foodSuggestionBaseWrapper from './baseWrapper'

export default {
  name: 'FoodSuggestionPdfWrapper',
  extends: foodSuggestionBaseWrapper
}
</script>
